<template>
  <hsc-window-style-white>
    <hsc-window
      :title="sono"
      :closeButton="true"
      :resizable="true"
      :isScrollable="true"
      :isOpen.sync="open"
      positionHint="center"
      :minWidth="500"
      :maxWidth="1750"
      :minHeight="500"
      :maxHeight="800"
    >
      <b-overlay class="loading-overlay" v-bind:show="loading" rounded="sm">
        <div id="sales-order-container">
          <b-row>
            <b-col class="col-4">
              <b-row class="text-center">
                <b-col>Sales Person</b-col>
                <b-col>Added By</b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>
                  <img class="headshot" v-bind:src="'data:image/jpeg;base64,'+salesOrder.salesmnPhoto" alt="">
                </b-col>
                <b-col>
                  <img class="headshot" v-bind:src="'data:image/jpeg;base64,'+salesOrder.addUserPhoto" alt="">
                </b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>{{ salesOrder.salesmnName }}</b-col>
                <b-col>{{ salesOrder.addUserName }}</b-col>
              </b-row>
            </b-col>
            <b-col class="col-3">
              <table class="table-striped table-hover table-small col-12">
                <tbody>
                <tr>
                  <td><b>Client:</b></td>
                  <td>{{ salesOrder.custno }}</td>
                </tr>
                <tr>
                  <td><b>Sales Order:</b></td>
                  <td>{{ sono }}</td>
                </tr>
                <tr>
                  <td><b>PO:</b></td>
                  <td>{{ salesOrder.po }}</td>
                </tr>
                <tr>
                  <td><b>Added:</b></td>
                  <td>{{ salesOrder.addedOn }}</td>
                </tr>
                <tr>
                  <td><b>Printed:</b></td>
                  <td>{{ salesOrder.printed }}</td>
                </tr>
                <tr>
                  <td><b>Order Status:</b></td>
                  <td>
                    <b-form-select size="sm" v-model="salesOrder.status" v-bind:options="statuses.options" @change="updateStatus"></b-form-select>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col class="col-1">
              <b-form>
                <!--<b-form-checkbox v-model="salesOrder.web">Web</b-form-checkbox>-->
                <b-form-checkbox v-model="salesOrder.hot" @change="updateHot">Hot</b-form-checkbox>
                <b-form-checkbox v-model="salesOrder.select" @change="updateSelect">Select</b-form-checkbox>
                <b-form-checkbox v-model="salesOrder.locked" @change="showLockSalesOrderOverlay">Locked</b-form-checkbox>
              </b-form>
            </b-col>
            <b-col class="col-2">
              <drop-file v-bind:sono="sono"></drop-file>
            </b-col>
            <b-col class="col-2">
              <download-files type="salesOrder" v-bind:sono="sono"></download-files>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <h4>Line Items</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table v-bind:items="lineItems.items" v-bind:fields="lineItemFields" small hover striped></b-table>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <h4>Client Notes</h4>
              <div v-for="note in clientNotes" v-bind:key="'client-note'+note">
                {{ note }}
              </div>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <b-tabs content-class="mt-3" fill>
                <b-tab title="Status Changes">
                  <h4>Status Changes</h4>
                  <b-table v-bind:items="statusChanges.updates" v-bind:fields="statusChangeFields" small hover striped></b-table>
                </b-tab>
                <b-tab active title="Order Notes">
                  <h4>Order Notes</h4>
                  <div v-if="note.trim()">
                    <div v-for="note in salesOrder.notes" v-bind:key="'sales-order-note'+note">
                      {{ note }}
                    </div>
                  </div>
                  <div>
                    <b-form inline>
                      <b-form-group>
                        <b-form-input v-model="orderNote" size="sm" placeholder="Note" required></b-form-input>
                        <b-button variant="primary" size="sm" @click="submitOrderNote">Save</b-button>
                      </b-form-group>
                    </b-form>
                  </div>
                </b-tab>
                <b-tab title="Issues">
                  <h4>Issues</h4>
                  <b-table v-bind:items="issues" v-bind:fields="issueFields" small hover striped></b-table>
                </b-tab>
                <b-tab v-bind:title="'Photos ('+photos.count+')'">
                  <h4>Photos</h4>
                  <sales-order-photo v-for="photo in photos.photos" v-bind:key="photo.photoId" v-bind:src="photo.photo"></sales-order-photo>
                </b-tab>
                <b-tab title="Lock Notes">
                  <h4>Lock Notes</h4>
                  <b-table v-bind:items="lockNotes" small hover striped></b-table>
                </b-tab>
                <b-tab title="Tracking">
                  <h4>Tracking</h4>
                  <b-table v-bind:items="tracking.tracking" v-bind:fields="trackingFields" small hover striped>
                    <template v-slot:cell(trackingNumber)="row">
                      <b-button variant="outline" @click="row.toggleDetails">
                        {{ row.item.trackingNumber }}
                      </b-button>
                    </template>
                    <template slot="row-details" slot-scope="row">
                      <b-table v-bind:items="row.item.events" v-bind:fields="trackingEventFields" small hover striped></b-table>
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </hsc-window>
  </hsc-window-style-white>
</template>

<script>

import store from '@/store'
import SalesOrderPhoto from '../../sales_orders/SalesOrderPhoto'
import LockSalesOrderOverlay from './LockSalesOrderOverlay'
import DownloadRelatedFiles from '../../misc/DownloadRelatedFiles'
import DropSalesOrderFile from '../../sales_orders/DropSalesOrderFile'

export default {
  name: 'SalesOrderOverlay',
  props: ['sono'],
  data () {
    return {
      loading: true,
      open: true,
      orderNote: '',
      lineItemFields: [
        {'key': 'lineNumber', 'label': 'Line Number'},
        {'key': 'type', 'label': 'Type'},
        {'key': 'item', 'label': 'Item'},
        {'key': 'partNumber', 'label': 'Part Number'},
        {'key': 'clientPartNumber', 'label': 'Client Part Number'},
        {'key': 'price', 'label': 'Price'},
        {'key': 'originalExtendedPrice', 'label': 'Ext Price'},
        {'key': 'originalQuantityOrdered', 'label': 'Ordered Qty'},
        {'key': 'shippedQuantity', 'label': 'Shipped Qty'},
        {'key': 'openQuantity', 'label': 'Open Qty'},
        {'key': 'location', 'label': 'Location'},
        {'key': 'reqDate', 'label': 'Req Date'}
      ],
      statusChangeFields: [
        {'key': 'name', 'label': 'Name'},
        {'key': 'status', 'label': 'Status'},
        {'key': 'agent', 'label': 'User'},
        {'key': 'created_on', 'label': 'Date'}
      ],
      issueFields: [
        {'key': 'name', 'label': 'User'},
        {'key': 'issueCode', 'label': 'Issue Code'},
        {'key': 'details', 'label': 'Details'},
        {'key': 'createdOn', 'label': 'Created On'}
      ],
      trackingFields: [
        {'key': 'trackingNumber', 'label': 'Tracking #'},
        {'key': 'estimatedDeliveryDate', 'label': 'Estimated Delivery Date'},
        {'key': 'actualDeliveryDate', 'label': 'Actual Delivery Date'},
        {'key': 'shipDate', 'label': 'Shipping Date'},
        {'key': 'statusDescription', 'label': 'Status'}
      ],
      trackingEventFields: [
        {'key': 'carrierOccurredAt', 'label': 'Event Date'},
        {'key': 'cityLocality', 'label': 'City'},
        {'key': 'stateProvince', 'label': 'State'},
        {'key': 'postalCode', 'label': 'Zip'},
        {'key': 'description', 'label': 'Description'},
        {'key': 'signer', 'label': 'Signed By'}
      ]
    }
  },
  components: {
    'sales-order-photo': SalesOrderPhoto,
    'drop-file': DropSalesOrderFile,
    'download-files': DownloadRelatedFiles
  },
  methods: {
    submitOrderNote () {
      // Get the date and time.
      const date = new Date()
      const dateString = date.toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: '2-digit'})
      const time = date.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true})

      const initials = this.$session.get('initials')

      // Build the note.
      const note = 'Note: ' + this.orderNote + ' by ' + initials + ' on ' + dateString + ' ' + time

      // Add the note to the notes array and reset the input.
      this.salesOrder.notes.push(note)
      this.orderNote = ''

      // Submit action to update the notes.
      const payload = {'salesOrderNumber': this.sono.trim(), 'note': note}
      store.dispatch('sales_orders/updateSalesOrderNotes', payload)
    },
    updateStatus () {
      const status = this.salesOrder.status.trim()
      const payload = {'salesOrderNumber': this.sono.trim(), 'status': status}
      store.dispatch('sales_orders/updateSalesOrderStatus', payload).then(() => {
        store.dispatch('sales_orders/fetchSalesOrderStatusChanges', this.sono.trim())
      })
    },
    updateHot () {
      const payload = {'salesOrderNumber': this.sono.trim(), 'hot': this.salesOrder.hot}
      store.dispatch('sales_orders/updateSalesOrderHot', payload).then(() => {
        store.dispatch('dashboard/fetchHotOrders')
      })
    },
    updateSelect () {
      const payload = {'salesOrderNumber': this.sono.trim(), 'select': this.salesOrder.select}
      store.dispatch('sales_orders/updateSalesOrderSelect', payload)
    },
    toggleLocked () {
      this.salesOrder.locked = !this.salesOrder.locked
    },
    showLockSalesOrderOverlay () {
      // Toggle the locked input back.
      this.toggleLocked()

      // Get a reference to the dialog.
      const dlg = this.$dlg

      // Get a reference to the toggleLocked method so that it can be used in the closeMethod callback.
      const toggleLocked = this.toggleLocked

      // Get the key so that it can be used in the closeMethod callback.
      const key = this.$dlg.modal(LockSalesOrderOverlay, {
        title: 'Manage SO Lock',
        height: 250,
        params: {
          sono: this.sono.trim(),
          locked: this.salesOrder.locked,
          closeMethod: function () {
            dlg.close(key)
            toggleLocked()
            store.dispatch('sales_orders/fetchSalesOrderLockNotes')
          }
        }
      })
    }
  },
  computed: {
    salesOrder () {
      return store.state.sales_orders.salesOrder
    },
    lineItems () {
      return store.state.sales_orders.lineItems
    },
    statuses () {
      return store.state.sales_orders.statuses
    },
    statusChanges () {
      return store.state.sales_orders.statusChanges
    },
    clientNotes () {
      return store.state.sales_orders.clientNotes
    },
    issues () {
      const issues = []
      for (let obj of store.state.sales_orders.issues.issues) {
        issues.push({
          name: obj.addedBy.firstName + ' ' + obj.addedBy.lastName,
          issueCode: obj.code + ' - ' + obj.description,
          details: obj.details,
          createdOn: obj.createdOn
        })
      }
      return issues
    },
    photos () {
      return store.state.sales_orders.photos
    },
    lockNotes () {
      const notes = []
      for (let obj of store.state.sales_orders.lockNotes.notes) {
        notes.push({
          actionBy: obj.actionBy.firstName + ' ' + obj.actionBy.lastName,
          actionOn: obj.lockedOn,
          action: obj.action,
          note: obj.note
        })
      }
      return notes
    },
    tracking () {
      return store.state.sales_orders.tracking
    }
  },
  beforeMount () {
    store.dispatch('sales_orders/fetchSalesOrder', this.sono.trim()).then((response) => {
      // If there was an error fetching the SO, display an alert and close the current overlay.
      if (response.success === false) {
        const dlg = this.$dlg
        this.$dlg.alert(response.message, function () { dlg.closeAll() }, {language: 'en'})
        return
      }

      store.dispatch('sales_orders/fetchSalesOrderStatuses')
      store.dispatch('sales_orders/fetchSalesOrderStatusChanges', this.sono.trim())
      store.dispatch('sales_orders/fetchSalesOrderIssues', this.sono.trim())
      store.dispatch('sales_orders/fetchSalesOrderPhotos', this.sono.trim())
      store.dispatch('sales_orders/fetchSalesOrderLockNotes', this.sono.trim())
      store.dispatch('sales_orders/fetchClientNotes', this.salesOrder.custno.trim())
      store.dispatch('sales_orders/fetchSalesOrderTracking', this.sono.trim())
      store.dispatch('sales_orders/fetchSalesOrderLineItems', this.sono.trim()).then(() => {
        this.loading = false
      })
    })
  },
  beforeDestroy () {
    store.dispatch('sales_orders/resetSalesOrder')
  }
}
</script>

<style>

  .loading-overlay {
    height: 100%
  }
  .headshot {
    height: 8em;
    clip-path: circle();
  }
  #sales-order-container {
    height: 100%;
    padding: 2em;
  }
</style>
